import SharedAudioContext from './shared-audio-context.js';

class AudioBlobPlayer {
    constructor (blob) {
        this.audioContext = SharedAudioContext();
        this.audio = new Audio();
        this.sourceElement = document.createElement('source');
        this.sourceElement.type = blob.type || 'audio/wav';
        this.audio.append(this.sourceElement)
        this.sourceElement.src = URL.createObjectURL(blob);
        this.source = this.audioContext.createMediaElementSource(this.audio);
        this.source.connect(this.audioContext.destination);
    }

    play (onEnded) {
        this.audio.currentTime = 0;
        this.audio.onended = onEnded;
        this.audio.play();
    }

    stop () {
        this.audio.pause();
        this.audio.currentTime = 0;
    }

    release() {
        this.stop();
        if (this.audio) {
            if (this.sourceElement) {
                this.audio.removeChild(this.sourceElement);
            }
            this.audio = null;
        }
        if (this.sourceElement) {
            if (this.sourceElement.src) {
                URL.revokeObjectURL(this.sourceElement.src);
            }
            this.sourceElement = null;
        }
        if (this.source) {
            this.source.disconnect()
        }
    }
}

export default AudioBlobPlayer;
